import React from "react";
import { FormGroup, Input } from "reactstrap";
import jwt from 'jwt-simple';
import { array } from 'prop-types';

import history from "../history"

const moment = require('moment-timezone');

const secret_jwt = 'DOUBLE_JASMINE';

function DecodeSession() {
  let session = localStorage.getItem("session");
  // decode
  var decoded = jwt.decode(session, secret_jwt);

  return decoded;
}

function EncodeSession(payload) {
  // encode
  var session = jwt.encode(payload, secret_jwt);
  localStorage.setItem("session", session);

  return session;
}

function Authentication() {
  let session = localStorage.getItem("session");

  if (session === null) {
    return false;
  } else {
    return true;
  }
}

function redirectAuth(mode) {
  if (mode === 'single') {
    history.push("/admin/dashboard")
  } else {
    history.push("/select-system")
  }
}

function setPlattype(plant_id) {
  localStorage.setItem('select_planttype', plant_id)
}

// ------------------------------------------------- Get Base 64 Image Profile --------------------------------
// Select Image File
function getBase64(file, cb) {
  if (file.size > 10000000) {
    alert("ไฟล์รูปมาขนาดใหญ่เกิน 10 MB โปรดเลือกใหม่!");
  } else {
    this.setState({ loadingSelectImage: true });
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result)
      // console.log(reader.result)
    };
    reader.onerror = function (error) {
      // console.log('Error: ', error);
    };
  }
}

function validateEmail_require(email) {
  var res_email = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;

  if (email === "" || !res_email.test(email) || email.length > 50) {
    return false;
  }

  return true;
}

function validateEmail_norequire(email) {
  var res_email = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;

  if (email.length === 0) {
    return true;
  } else {
    if (!res_email.test(email) || email.length > 50) {
      return false;
    }
  }

  return true;
}

function toTimeZone(time, zone) {
  var format = 'YYYY-MM-DD HH:mm:ss';
  return moment(time, format).tz(zone).format(format);
}

function toDateThai(timestamp) {
  let date = new Date(timestamp);
  let date_format = `${date.getDate()} ${getMonthNameThai(date.getMonth() + 1)} ${(date.getFullYear() + 543).toString().substr(2)}`;

  return date_format;
}

function toDateThaiMonthFull(timestamp) {
  let date = new Date(timestamp);
  let date_format = `${date.getDate()} ${getMonthNameThaiFull(date.getMonth() + 1)} ${(date.getFullYear() + 543).toString()}`;

  return date_format;
}

function getMonthNameThaiFull(month) {
  let result;

  switch (month) {
    case 1: result = "มกราคม";
      break;
    case 2: result = "กุมภาพันธ์";
      break;
    case 3: result = "มีนาคม";
      break;
    case 4: result = "เมษายน";
      break;
    case 5: result = "พฤษภาคม";
      break;
    case 6: result = "มิถุนายน";
      break;
    case 7: result = "กรกฎาคม";
      break;
    case 8: result = "สิงหาคม";
      break;
    case 9: result = "กันยายน";
      break;
    case 10: result = "ตุลาคม";
      break;
    case 11: result = "พฤศจิกายน";
      break;
    case 12: result = "ธันวาคม";
      break;
    default: result = "";
      break;
  }
  return result;
}

function getMonthNameThai(month) {
  let result;

  switch (month) {
    case 1: result = "ม.ค.";
      break;
    case 2: result = "ก.พ.";
      break;
    case 3: result = "มี.ค.";
      break;
    case 4: result = "เม.ย.";
      break;
    case 5: result = "พ.ค.";
      break;
    case 6: result = "มิ.ย.";
      break;
    case 7: result = "ก.ค.";
      break;
    case 8: result = "ส.ค.";
      break;
    case 9: result = "ก.ย.";
      break;
    case 10: result = "ต.ค.";
      break;
    case 11: result = "พ.ย.";
      break;
    case 12: result = "ธ.ค.";
      break;
    default: result = "";
      break;
  }
  return result;
}

function findWarrantyStatus(status_id) {
  let warranty_status = [
    {
      "status_id": 1,
      "status_name": "รอการยืนยัน",
      "alert_status": "รอการยืนยัน"
    },
    {
      "status_id": 2,
      "status_name": "ยืนยันว่าอยู่ในพื้นที่ประกาศภัย",
      "alert_status": "อยู่ในพื้นที่ประกาศภัยพิบัติ"
    },
    {
      "status_id": 3,
      "status_name": "ยืนยันว่าไม่อยู่ในพื้นที่ประกาศภัย",
      "alert_status": "อยู่นอกพื้นที่ประกาศภัยพิบัติ"
    }
  ]

  let result_filter = warranty_status.filter((item) => item.status_id === status_id);
  let result = result_filter[0]
  return result;
}

function filterWarranty(warranty_array, filterProps) {
  let filter_result;

  if (filterProps.search !== undefined && filterProps.search !== "") {
    filter_result = warranty_array.filter(function (item) {
      let condition_search = (
        (item.name).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.warranty_dmgtype).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.province).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.amphoe).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.tambon).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.moo).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.community).toLowerCase()).includes((filterProps.search).toLowerCase()
        )

      return (
        getFilter(item.warranty_dmgtype, filterProps.dmgtype, "checkbox", "dmgtype_name") &&
        getFilter(item.warranty_full, filterProps.fieldset, "checkbox", "value") &&
        getFilter(item.status_id, filterProps.status, "checkbox", "status_id") &&
        getFilter(item.province, filterProps.province, "select") &&
        getFilter(item.amphoe, filterProps.amphoe, "select") &&
        getFilter(item.tambon, filterProps.tambon, "select") &&
        getFilter(item, filterProps, "communitymoo")
      ) && (condition_search)
    });

  } else {
    filter_result = warranty_array.filter(function (item) {
      return getFilter(item.warranty_dmgtype, filterProps.dmgtype, "checkbox", "dmgtype_name") &&
        getFilter(item.warranty_full, filterProps.fieldset, "checkbox", "value") &&
        getFilter(item.status_id, filterProps.status, "checkbox", "status_id") &&
        getFilter(item.province, filterProps.province, "select") &&
        getFilter(item.amphoe, filterProps.amphoe, "select") &&
        getFilter(item.tambon, filterProps.tambon, "select") &&
        getFilter(item, filterProps, "communitymoo")
    });
  }

  return filter_result;
}

function filterWebUsers(webusers_array, filterProps) {
  let filter_result;

  if (filterProps.search !== undefined && filterProps.search !== "") {
    filter_result = webusers_array.filter(function (item) {
      let condition_search = (
        (item.name).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.email).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.mobile).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.role_name).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.branch_pro_name).toLowerCase()).includes((filterProps.search).toLowerCase()) ||
        ((item.branch_name).toLowerCase()).includes((filterProps.search).toLowerCase()
        )

      return (
        getFilter(item.role_name, filterProps.userrole, "checkbox", "role_name") &&
        getFilter(item.user_active, filterProps.useractive, "checkbox", "value") &&
        getFilter(item.branch_pro_name, filterProps.branchprov, "select") &&
        getFilter(item.branch_name, filterProps.branch, "select")
      ) && (condition_search)
    });

  } else {
    filter_result = webusers_array.filter(function (item) {
      return getFilter(item.role_name, filterProps.userrole, "checkbox", "role_name") &&
        getFilter(item.user_active, filterProps.useractive, "checkbox", "value") &&
        getFilter(item.branch_pro_name, filterProps.branchprov, "select") &&
        getFilter(item.branch_name, filterProps.branch, "select")
    });
  }

  return filter_result;
}

// ------------------------------ Status_filter ---------------------------------
function VerifyStatusFilter(province, amphoe, tambon, moo, community, select_communitymoo) {
  let statusfilter_result = false;
  // filter only province
  if ((province !== undefined && province !== "") && (amphoe === undefined || amphoe === "") && (tambon === undefined || tambon === "")) {
    // have value filter moo, community
    if ((select_communitymoo === "moo") && (moo !== undefined && moo !== "")) {
      // console.log('have value filter moo, province')
      statusfilter_result = true;
    }
    else if ((select_communitymoo === "community") && (community !== undefined && community !== "")) {
      // console.log('have value filter community, province')
      statusfilter_result = true;
    }
    // no value filter moo, community
    else {
      // console.log('no value filter moo, community, province');
      statusfilter_result = true;
    }
  }
  // filter province and amphoe
  else if ((province !== undefined && province !== "") && (amphoe !== undefined && amphoe !== "") && (tambon === undefined || tambon === "")) {
    // have value filter moo, community
    if ((select_communitymoo === "moo") && (moo !== undefined && moo !== "")) {
      // console.log('have value filter moo, province, amphoe')
      statusfilter_result = true;
    }
    else if ((select_communitymoo === "community") && (community !== undefined && community !== "")) {
      // console.log('have value filter moo, province, amphoe')
      statusfilter_result = true;
    }
    // no value filter moo, community
    else {
      // console.log('no value filter moo, community, province, amphoe');
      statusfilter_result = true;
    }
  }
  // filter province, amphoe, tambon
  else if ((province !== undefined && province !== "") && (amphoe !== undefined && amphoe !== "") && (tambon !== undefined && tambon !== "")) {
    // have value filter moo, community
    if ((select_communitymoo === "moo") && (moo !== undefined && moo !== "")) {
      // console.log('have value filter moo, province, amphoe, tambon')
      statusfilter_result = true;
    }
    else if ((select_communitymoo === "community") && (community !== undefined && community !== "")) {
      // console.log('have value filter community, province, amphoe, tambon')
      statusfilter_result = true;
    }
    // no value filter moo, community
    else {
      // console.log('no value filter moo, community, province, amphoe, tambon');
      statusfilter_result = true;
    }
  }
  // no filter
  else {
    statusfilter_result = false;
  }

  // console.log("statusfilter_result: " + statusfilter_result)
  return statusfilter_result;
}

function stringToHTML(str) {
  var dom = document.createElement('div');
  dom.innerHTML = str;
  return dom;
};

function parseHTML(html) {
  var t = document.createElement('template');
  t.innerHTML = html;
  return t.content.cloneNode(true);
}

function getFilter(array_item, filter_value, type_filter, attribute) {
  switch (type_filter) {
    case "checkbox":
      // code block
      let checkbox_filterarray = filter_value;
      const arrayHasFilter = checkbox_filterarray.some(function (item) {
        return (item[attribute] === array_item) && item.isChecked
      });
      return arrayHasFilter;
    case "select":
      // code block
      if (filter_value !== undefined && filter_value !== "") {
        return array_item === filter_value;
      }
      return true;
    case "communitymoo":
      let select_communitymoo = filter_value.select_communitymoo;
      let input_communitymoo;

      if (select_communitymoo === "community") {
        input_communitymoo = array_item.community;

        if (input_communitymoo !== undefined && input_communitymoo !== "") {
          return (input_communitymoo).toLowerCase().includes((filter_value.community).toLowerCase());
        }
      }
      // moo
      else {
        input_communitymoo = array_item.moo;

        if (input_communitymoo !== undefined && input_communitymoo !== "") {
          return (input_communitymoo).toLowerCase().includes((filter_value.moo).toLowerCase());
        }
      }
      return true;
    default:
      // code block
      return false;
  }
}

function setWarrantyTable(array, unique, self) {
  let userrole_canapprove = [1, 2, 4];

  let warranty = array.map((item, key) => {
    let status_validate;

    if (userrole_canapprove.includes(self.state.user_role)) {
      status_validate = (
        <FormGroup style={{ marginBottom: '0px' }}>
          <Input
            key={key}
            type="select"
            name="warrantyStatus"
            id={`warranty${unique + key}`}
            value={item.status_id}
            onChange={(e) => {
              let all_warranty = self.state.all_warranty;

              let warranty_filter = all_warranty.filter((i) => i.warranty_id === item.warranty_id);
              let warranty_exist = warranty_filter[0];
              let oldStatusId = warranty_exist.status_id

              self.handleApproveWarranty(item.warranty_id, item.warranty_full, oldStatusId, parseInt(e.target.value))
            }}
          >
            {self.state.optionsStatus.map((item, key) => {
              return (
                <option
                  key={key}
                  value={item.status_id}
                >
                  {item.status_name}
                </option>
              )
            })}
          </Input>
        </FormGroup>
      )
    } else {
      status_validate = item.status_name
    }

    const container = {
      no: key + 1,
      warranty_id: item.warranty_id,
      name: item.w_fname + " " + item.w_lname,
      warranty_full: item.warranty_full,
      warranty_dmgtype: item.warranty_dmgtype,
      province: item.f_province === null ? "-" : item.f_province,
      amphoe: item.f_amphoe === null ? "-" : item.f_amphoe,
      tambon: item.f_tambon === null ? "-" : item.f_tambon,
      moo: item.warranty_moo === null ? "-" : item.warranty_moo,
      community: item.warranty_community === null ? "-" : item.warranty_community,
      status_id: item.status_id,
      status_name: item.status_name,
      status_validate: status_validate,
      form_complete: item.warranty_full,
      branch_pro_name: item.branch_pro_name,
      branch_name: item.branch_name,
      warranty_no: item.warranty_no,
      w_citizenid: item.w_citizenid,
      w_address: item.w_address,
      w_province: item.w_province,
      w_amphoe: item.w_amphoe,
      w_tambon: item.w_tambon,
      w_postcode: item.w_postcode,
      w_timestamp: toDateThai(item.w_timestamp),
      w_dmgdate: toDateThai(item.w_dmgdate),
      w_dmgarea: item.warranty_dmgarea,
      w_plantdate: toDateThai(item.w_plantdate),
      w_harvestdate: toDateThai(item.w_harvestdate),
      f_fieldno: item.f_fieldno === null ? "-" : item.f_fieldno,
      f_area: item.warranty_full ? `${item.f_rai}ไร่ ${item.f_ngan}งาน ${item.f_sqwa}วา` : "-",
      f_postcode: item.f_postcode === null ? "-" : item.f_postcode,
      f_polyimg: item.polyimg === null ? "-" : item.polyimg,
      f_polyWKT: item.poly_wkt === null ? "-" : item.poly_wkt,
      dmg_img: item.dmg_img
    }
    return container;
  })

  return warranty;
}

function setWebUsersTable(array, self) {
  let web_users = array.map((item, key) => {
    let status;

    if ((self.state.active_userinfo).role_id === 1 || (self.state.active_userinfo).role_id === 2) {
      status = (
        <FormGroup style={{ marginBottom: '0px' }}>
          <Input
            key={key}
            type="select"
            name="userActive"
            id={`WEBID${key}`}
            value={item.user_active}
            onChange={(e) => self.handleChangeUserActiveWeb(item.uid, e.target.value)}
          >
            <option value={false}>ปิดใช้งาน</option>
            <option value={true}>เปิดใช้งาน</option>
          </Input>
        </FormGroup>
      )
    } else {
      status = item.user_active ? "เปิดการใช้งาน" : "ปิดการใช้งาน";
    }

    const container = {
      no: key + 1,
      uid: item.uid,
      name: item.name,
      email: item.email,
      mobile: item.tel,
      role: item.role_id,
      role_name: item.role_name,
      user_active: item.user_active,
      status: status,
      branch_pro_name: item.branch_pro_name !== null ? item.branch_pro_name : "-",
      branch_name: item.branch_name !== null ? item.branch_name : "-",
    }
    return container;
  })

  return web_users;
}

export {
  DecodeSession,
  EncodeSession,
  Authentication,
  setPlattype,
  redirectAuth,
  // validate
  validateEmail_require,
  validateEmail_norequire,
  // totime
  toTimeZone,
  getMonthNameThai,
  toDateThai,
  toDateThaiMonthFull,
  // picker image
  getBase64,
  findWarrantyStatus,
  filterWarranty,
  filterWebUsers,
  VerifyStatusFilter,
  // stringToHTML
  stringToHTML,
  parseHTML,
  setWarrantyTable,
  setWebUsersTable,
};